import type { SVGProps } from 'react';

export const Remove = (props: SVGProps<any>) => (
  <svg
    height="24px"
    role="img"
    viewBox="0 0 24 24"
    width="24px"
    x="0px"
    xmlSpace="preserve"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    y="0px"
    {...props}
  >
    <title>{'remove'}</title>
    <circle cx={12} cy={12} fill={props.fill} r={12} />
    <polygon
      fill="white"
      points="17,7.5 16.5,7 12,11.5 7.5,7 7,7.5 11.5,12 7,16.5 7.5,17 12,12.5 16.5,17 17,16.5 12.5,12"
    />
  </svg>
);
